<template>
  <div>
    <headerNav title="云微商管理" />
    <div class="tm">
      <div class="tm-order">
        <div class="tm-order-tit">
          <div>订单管理</div>
          <div class="tm-order-tit-fr" @click="goto('cloundorderlist', 0)">
            查看全部
            <van-icon
              class="main-list-icon-left"
              :size="14"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="you"
            />
          </div>
        </div>
        <div class="tm-order-list">
          <div class="tm-order-item" @click="goto('cloundorderlist', 1)">
            <div class="tm-order-icon">
              <van-icon
                class="main-list-icon-right"
                :badge="orderCount4"
                :size="44"
                :color="$abctheme.basecolor"
                class-prefix="abc-icon"
                name="quanbu"
              />
            </div>
            <div class="tm-order-wz">待付款</div>
            <van-tag
              class="um-order-mian-conf-tag"
              round
              v-if="orderCount4"
              type="danger"
              >{{ orderCount4 }}</van-tag
            >
          </div>
          <div class="tm-order-item" @click="goto('cloundorderlist', 2)">
            <div class="tm-order-icon">
              <van-icon
                class="main-list-icon-right"
                :size="44"
                :color="$abctheme.basecolor"
                class-prefix="abc-icon"
                name="yifahuo"
              />
            </div>
            <div class="tm-order-wz">待处理</div>
            <van-tag
              class="um-order-mian-conf-tag"
              round
              v-if="orderCount1"
              type="danger"
              >{{ orderCount1 }}</van-tag
            >
          </div>
          <div class="tm-order-item" @click="goto('cloundorderlist', 3)">
            <div class="tm-order-icon">
              <van-icon
                class="main-list-icon-right"
                :badge="orderCount2"
                :size="44"
                :color="$abctheme.basecolor"
                class-prefix="abc-icon"
                name="daifahuo"
              />
            </div>
            <div class="tm-order-wz">待发货</div>
            <van-tag
              class="um-order-mian-conf-tag"
              round
              v-if="orderCount2"
              type="danger"
              >{{ orderCount2 }}</van-tag
            >
          </div>
          <div class="tm-order-item" @click="goto('cloundorderlist', 4)">
            <div class="tm-order-icon">
              <van-icon
                class="main-list-icon-right"
                :badge="orderCount3"
                :size="44"
                :color="$abctheme.basecolor"
                class-prefix="abc-icon"
                name="tubiaozhizuomobankuozhan-"
              />
            </div>
            <div class="tm-order-wz">待收货</div>
            <van-tag
              class="um-order-mian-conf-tag"
              round
              v-if="orderCount3"
              type="danger"
              >{{ orderCount3 }}</van-tag
            >
          </div>
           <div class="tm-order-item" @click="goto('cloundorderlist', 5)">
            <div class="tm-order-icon">
              <van-icon
                class="main-list-icon-right"
                :badge="orderCount5"
                :size="44"
                :color="$abctheme.basecolor"
                class-prefix="abc-icon"
                name="tuikuan"
              />
            </div>
            <div class="tm-order-wz">退款中</div>
            <van-tag
              class="um-order-mian-conf-tag"
              round
              v-if="orderCount5"
              type="danger"
              >{{ orderCount5 }}</van-tag
            >
          </div>
        </div>
      </div>

      <div class="tm-store">
        <div class="tm-store-wz">店铺数据</div>
        <div class="tm-store-list">
          <div class="tm-store-item">
            <div>{{ storedata.todayTradeNum }}</div>
            <div>今日订单数</div>
          </div>
          <div class="tm-store-item">
            <div>{{ orderCount4 }}</div>
            <div>待付款</div>
          </div>
          <div class="tm-store-item">
            <div>{{ orderCount2 }}</div>
            <div>待发货</div>
          </div>
          <div class="tm-store-item">
            <div>{{ storedata.yestodayTradeTotalAmount }}</div>
            <div>昨日成交金额</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orderCount1:0,
      orderCount2:0,
      orderCount3:0,
      orderCount4:0,
      orderCount5:0,
      storedata: {},
    };
  },
  created() {
    this.ajax
      .post("/api/services/app/PhoneTrade/QueryOrder", {
        tid: "",
        name: "",
        sku: "",
        tranferState: 1,
        productSku: "",
        sorting: "",
        maxResultCount: 1,
        refundStatus: 0,
        skipCount: 0,
      })
      .then((x) => {
        this.orderCount1 = x.result.totalCount;
      });
    this.ajax
      .post("/api/services/app/PhoneTrade/QueryOrder", {
        tid: "",
        name: "",
        sku: "",
        tranferState: 2,
        productSku: "",
        sorting: "",
        maxResultCount: 1,
        refundStatus: 0,
        skipCount: 0,
      })
      .then((x) => {
        this.orderCount2 = x.result.totalCount;
      });
    this.ajax
      .post("/api/services/app/PhoneTrade/QueryOrder", {
        tid: "",
        name: "",
        sku: "",
        tranferState: 3,
        productSku: "",
        sorting: "",
        maxResultCount: 1,
        refundStatus: 0,
        skipCount: 0,
      })
      .then((x) => {
        this.orderCount3 = x.result.totalCount;
      });
    this.ajax
      .post("/api/services/app/PhoneTrade/QueryOrder", {
        tid: "",
        name: "",
        sku: "",
        tranferState: 4,
        productSku: "",
        sorting: "",
        maxResultCount: 1,
        refundStatus: 0,
        skipCount: 0,
      })
      .then((x) => {
        this.orderCount4 = x.result.totalCount;
      });
      this.ajax
      .post("/api/services/app/PhoneTrade/QueryOrder", {
        tid: "",
        name: "",
        sku: "",
        tranferState: 5,
        productSku: "",
        sorting: "",
        maxResultCount: 1,
        refundStatus: 1,
        skipCount: 0,
      })
      .then((x) => {
        this.orderCount5 = x.result.totalCount;
      });
    this.ajax.post("/api/services/app/PhoneClound/QueryCloundStoreData").then((x) => {
      this.storedata = x.result;
    });
  },
  methods: {
    goto(url, state) {
      if (state) {
        this.$router.push({ path: url, query: { state: state } });
      } else {
        this.$router.push({ path: url });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tm {
  font-size: 12px;
  margin: 10px;
}

.tm-order,
.tm-store {
  padding: 10px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 1px 1px 3px #c5c5c5;
  margin-bottom: 10px;
}
.tm-order-tit,
.tm-store-wz {
  font-size: 16px;
  font-weight: bold;
  position: relative;
}
.tm-order-tit-fr {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 14px;
  font-weight: 100;
}
.tm-order-list,
.tm-store-list {
  text-align: left;
  padding: 10px;
}
.tm-order-item {
  display: inline-block;
  width: 25%;
  text-align: center;
  padding: 10px 0;
}
.tm-store-item {
  display: inline-block;
  width: 25%;
  text-align: center;
  padding: 10px 0;
}
.um-order-mian-conf-tag {
  top: -65px;
  right: -47px;
  float: left;
}
</style>
